import { RefObject } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any --- hack to extract attributes from smash-ballon
export const handleAttributes = (base: any, ref: RefObject<HTMLDivElement>) => {
  if (base) {
    for (let j = 0; j <= base.getAttributeNames().length; j++) {
      const attributeName = base.getAttributeNames()[j];
      if (attributeName && !attributeName.includes("data-")) {
        ref.current?.setAttribute(
          attributeName,
          base.getAttribute(attributeName) || "",
        );
      }
    }
  }
};
